// import AsyncStorage from '@react-native-async-storage/async-storage'
import axios from "axios";
import ApiConstants from "constanst";
import Cookies from "universal-cookie";

const cookies = new Cookies();
// import Notify from 'devextreme/ui/notify'

export default async function api(path: string, params: {} | null = {}, method: string, token?: string | null) {
  if (!token) {
    token = cookies.get("token");
  }
  let options: {};
  if (!params) {
    options = {
      url: ApiConstants.BASE_URL + path,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        ...(token && { token: token }),
      },
      method: method,
    };
  } else {
    options = {
      url: ApiConstants.BASE_URL + path,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        ...(token && { token: token }),
      },
      method: method,
      ...(params && { body: JSON.stringify(params) }),
      data: params,
    };
  }

  return axios(options)
    .then((resp) => {
      return resp.data;
    })
    .then((json) => json)
    .catch((error) => {        
      const message = { ...error };

      if (
        message &&
        message.response &&
        message.response.data &&
        message.response.data.message &&
        Array.isArray(message.response.data.message)
      ) {
        return Promise.reject(message?.response?.data?.message?.join("\n"));
      } else if (
        message &&
        message.response &&
        message.response.data &&
        message.response.data.message &&
        !Array.isArray(message.response.data.message)
      ) {
        return Promise.reject(message?.response?.data?.message);
      } else {
        return Promise.reject("Có lỗi xảy ra vui lòng thử lại");
      }
    });
}
